// RegShield Design System — v2.0
// Single source of truth for all colors, spacing, shadows

export const lightTheme = {
    // Backgrounds
    bgBase:      '#F1F5F9',
    bgCard:      '#FFFFFF',
    bgCardHover: '#F8FAFC',
    bgSidebar:   '#1C2434',
    bgHeader:    '#FFFFFF',
    bgInput:     '#FFFFFF',
    bgBadge:     '#F1F5F9',
    bgOverlay:   'rgba(0,0,0,0.5)',
  
    // Borders
    border:      '#E2E8F0',
    borderLight: '#F1F5F9',
  
    // Text
    textPrimary:   '#111827',
    textSecondary: '#6B7280',
    textTertiary:  '#9CA3AF',
    textInverse:   '#FFFFFF',
  
    // Brand
    brand:       '#3B82F6',
    brandDark:   '#1D4ED8',
    brandLight:  '#EFF6FF',
  
    // Status
    success:     '#10B981',
    successBg:   '#ECFDF5',
    warning:     '#F59E0B',
    warningBg:   '#FFFBEB',
    danger:      '#EF4444',
    dangerBg:    '#FEF2F2',
    purple:      '#8B5CF6',
    purpleBg:    '#F5F3FF',
  
    // Shadows
    shadowSm:    '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    shadowMd:    '0 4px 12px rgba(0,0,0,0.08)',
    shadowLg:    '0 8px 32px rgba(0,0,0,0.10)',
  
    // Sidebar specific
    sidebarText:        '#6B7280',
    sidebarTextHover:   '#111827',
    sidebarTextActive:  '#1D4ED8',
    sidebarBg:          '#FFFFFF',
    sidebarBgHover:     '#F1F5F9',
    sidebarBgActive:    '#EFF6FF',
    sidebarBorder:      '#E2E8F0',
    sidebarSection:     '#9CA3AF',
  };
  
  export const darkTheme = {
    // Backgrounds
    bgBase:      '#1A222C',
    bgCard:      '#24303F',
    bgCardHover: '#2A3947',
    bgSidebar:   '#1C2434',
    bgHeader:    '#24303F',
    bgInput:     '#2A3947',
    bgBadge:     '#2A3947',
    bgOverlay:   'rgba(0,0,0,0.7)',
  
    // Borders
    border:      '#334155',
    borderLight: '#2D3A4A',
  
    // Text
    textPrimary:   '#E2E8F0',
    textSecondary: '#94A3B8',
    textTertiary:  '#64748B',
    textInverse:   '#FFFFFF',
  
    // Brand
    brand:       '#3B82F6',
    brandDark:   '#2563EB',
    brandLight:  '#1E3A5F',
  
    // Status
    success:     '#10B981',
    successBg:   '#064E3B',
    warning:     '#F59E0B',
    warningBg:   '#451A03',
    danger:      '#EF4444',
    dangerBg:    '#450A0A',
    purple:      '#8B5CF6',
    purpleBg:    '#2E1065',
  
    // Shadows
    shadowSm:    '0 1px 3px rgba(0,0,0,0.3)',
    shadowMd:    '0 4px 12px rgba(0,0,0,0.4)',
    shadowLg:    '0 8px 32px rgba(0,0,0,0.5)',
  
    // Sidebar specific
    sidebarText:        '#94A3B8',
    sidebarTextHover:   '#E2E8F0',
    sidebarTextActive:  '#60A5FA',
    sidebarBg:          '#1A222C',
    sidebarBgHover:     'rgba(255,255,255,0.05)',
    sidebarBgActive:    'rgba(59,130,246,0.12)',
    sidebarBorder:      '#334155',
    sidebarSection:     '#475569',
  };
  
  // Context helper — use this in every component
  export const getTheme = (isDark) => isDark ? darkTheme : lightTheme;